import styled from 'styled-components'

import { theme } from '../../styles/theme'

export const Container = styled.div`
  position: relative;
  width: 100%;
  box-shadow: 0px 0px 10px 1px rgba(0, 0, 0, 0.1);
  border-radius: ${theme.border.smallRadius};
  padding: 8px;
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 20px;

  cursor: pointer;

  [data-name='message'] {
    position: absolute;
    right: 8px;
    top: 8px;
  }
`

export const Image = styled.img`
  width: 88px;
  height: 88px;
  border-radius: ${theme.border.smallRadius};
  border: 1px solid ${theme.colors.gray300};
  object-fit: cover;
`

export const ContractorInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`

export const ContractorTitle = styled.div`
  font-size: ${theme.font.sizes.normal};
  font-weight: ${theme.font.bold};
  width: calc(100% - 30px);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

export const ContractorDescription = styled.div`
  display: flex;
  align-items: flex-start;
  flex-wrap: wrap;
  gap: 4px;
  width: calc(100% - 20px);

  svg {
    width: 16px;
    height: 16px;

    path {
      fill: ${theme.colors.green3};
    }
  }
`

export const DescriptionTitle = styled.div`
  font-size: ${theme.font.sizes.small};
  font-weight: ${theme.font.normal};
  display: flex;
  color: ${theme.colors.gray500};
`

export const DescriptionValue = styled.div`
  font-size: ${theme.font.sizes.small};
  font-weight: ${theme.font.normal};
  color: ${theme.colors.gray700};
  align-self: flex-start;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-word;
  max-height: calc(2 * 1.2em);
  line-height: 1.2;
`

export const Circle = styled.div`
  position: absolute;
  top: 8px;
  right: 8px;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  z-index: 1000;
  background: ${theme.colors.erro};
`
